import type { IconType } from './Icon.js';

/**
 * Маппінг імен-іконок з hub.html (рядки на кшталт 'spider', 'crown', 'anchor')
 * на типи SVG-іконок з нашого набору. Жодних емодзі — лише SVG.
 *
 * Якщо ключа немає у мапі — повертаємо 'unknown' (буде відрисовано
 * generic-іконку з кружком-стрілкою з Icon.tsx default-case).
 */
export const ICON_MAP: Record<string, IconType> = {
  // ── Створіння ────────────────────────────────────────────────────────
  spider: 'arachnid', arachnid: 'arachnid',
  beast: 'beast', wolf: 'beast', cat: 'beast', bear: 'beast', boar: 'beast',
  snake: 'beast', deer: 'beast', bird: 'beast', bat: 'beast', fish: 'beast',
  claws: 'beast',          // когті/звір
  humanoid: 'humanoid', users: 'humanoid',
  undead: 'undead', skull: 'undead', grave: 'undead', bone: 'undead', tomb: 'undead',
  demon: 'demon', horns: 'demon',
  dragon: 'dragon', lindworm: 'dragon', wyvern: 'dragon',
  spirit: 'spirit', ghost: 'spirit', wisp: 'spirit', wings: 'spirit',
  fey: 'fey', leaf: 'fey', thorns: 'fey', tree: 'fey', vine: 'fey',
  construct: 'construct', golem: 'construct', gear: 'construct', machine: 'construct',
  fire: 'elemental-fire', flame: 'flame',
  water: 'elemental-water', wave: 'elemental-water', drop: 'elemental-water', rain: 'elemental-water',
  earth: 'elemental-earth', mountain: 'elemental-earth', cave: 'elemental-earth', rock: 'elemental-earth',
  air: 'elemental-air', wind: 'elemental-air', storm: 'elemental-air',
  aberration: 'aberration', eclipse: 'aberration',
  ooze: 'ooze', slime: 'ooze', blob: 'ooze',
  cultist: 'cultist', cloak: 'cultist', hood: 'cultist',
  bandit: 'bandit', mask: 'bandit', masks: 'bandit', thief: 'bandit',
  boss: 'boss',
  swarm: 'ooze',           // рій — найближче до ooze силуетом

  // ── Зброя й спорядження ─────────────────────────────────────────────
  sword: 'sword', swords: 'sword', blade: 'sword', axe: 'sword',
  dagger: 'dagger', knife: 'dagger',
  bow: 'bow',
  shield: 'shield', guard: 'shield', armor: 'shield',
  wand: 'wand',
  staff: 'staff', hammer: 'staff', mace: 'staff', spear: 'staff', polearm: 'staff',
  arrow: 'arrow',

  // ── Артефакти / окультне ───────────────────────────────────────────
  scroll: 'scroll',
  book: 'book', tome: 'book',
  potion: 'potion', elixir: 'potion',
  heart: 'heart',
  eye: 'eye',
  key: 'key',
  chest: 'chest', urn: 'chest', coins: 'chest', coin: 'chest', gold: 'chest',
  lantern: 'lantern', candle: 'lantern', torch: 'lantern',
  moon: 'moon', night: 'moon',
  sun: 'sun', star: 'sun', light: 'sun',
  hourglass: 'hourglass', time: 'hourglass',
  crown: 'crown', throne: 'crown', king: 'crown',
  rune: 'rune', crystal: 'rune', gem: 'rune', sigil: 'rune',

  // ── Локаційне / архітектура (мапим до найближчого за змістом) ───────
  anchor: 'chest',
  castle: 'shield',        // замок/фортеця → щит
  tower: 'shield',
  altar: 'rune',
  door: 'shield',
  lightning: 'wand',
  ice: 'shield',
};

export function iconTypeFor(name: string | undefined): IconType {
  if (!name) return 'unknown';
  return ICON_MAP[name.toLowerCase()] ?? 'unknown';
}
